import { ShieldAlert } from 'lucide-react';

interface ColumnMappingWarningModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ColumnMappingWarningModal({ isOpen, onConfirm, onCancel }: ColumnMappingWarningModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[60] p-4">
      <div
        className="bg-white rounded-xl shadow-2xl w-full max-w-md"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="column-warning-title"
        aria-describedby="column-warning-desc"
      >
        <div className="p-6">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-11 h-11 rounded-full bg-amber-100 flex items-center justify-center">
              <ShieldAlert className="w-5 h-5 text-amber-600" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 id="column-warning-title" className="text-base font-semibold text-gray-900">
                Mapeamento de colunas incompleto
              </h3>
              <p id="column-warning-desc" className="text-sm text-gray-600 mt-2 leading-relaxed">
                Você tem certeza que deseja avançar sem vincular <strong>IDDistribuidor</strong> e/ou <strong>IDIndustria</strong>?
                Essas duas colunas são importantes para disponibilizar corretamente a informação de acordo com as permissões do usuário e RLS.
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-100 bg-gray-50 rounded-b-xl">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Voltar e preencher
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="px-4 py-2 text-sm font-medium text-amber-700 bg-amber-100 border border-amber-200 rounded-lg hover:bg-amber-200 transition-colors"
          >
            Avançar mesmo assim
          </button>
        </div>
      </div>
    </div>
  );
}
 